import { render, staticRenderFns } from "./AllergenCollectionSetCard.vue?vue&type=template&id=083f103b&"
import script from "./AllergenCollectionSetCard.vue?vue&type=script&lang=js&"
export * from "./AllergenCollectionSetCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports